import { Timestamp, doc, runTransaction } from 'firebase/firestore';

export const getStandardTrialFields = (now = new Date(), source = '') => ({
  currentPlan: 'standard_trial',
  planName: 'standard_trial',
  planType: 'standard_trial',
  subscriptionStatus: 'trialing',
  isSubscription: false,
  standardTrialStatus: 'active',
  standardTrialStartedAt: Timestamp.fromDate(now),
  standardTrialEndsAt: Timestamp.fromDate(new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000)),
  standardTrialSource: source || 'unknown',
  standardTrialProjectLimit: 1,
  standardTrialWatermarkedDownloads: true,
});

export const getPendingStandardTrialFields = (source = 'unknown') => ({
  standardTrialStatus: 'pending_verification',
  standardTrialRequestedAt: Timestamp.now(),
  standardTrialSource: source,
});

export const activatePendingStandardTrial = async (db, user) => {
  if (!user?.uid || !user.emailVerified) return false;
  const userRef = doc(db, 'users', user.uid);
  return runTransaction(db, async (transaction) => {
    const snapshot = await transaction.get(userRef);
    if (!snapshot.exists()) return false;
    const data = snapshot.data();
    if (data.standardTrialStatus !== 'pending_verification' || data.standardTrialStartedAt) return false;
    transaction.update(userRef, getStandardTrialFields(new Date(), data.standardTrialSource));
    return true;
  });
};
